import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthYear',
})
export class MonthYearPipe implements PipeTransform {
  private readonly datePipe = inject(DatePipe);

  transform(date: any): unknown {
    if (date === '') {
      return 'Nu';
    }
    if (!date) {
      return null;
    }
    return this.datePipe.transform(date, 'MMMM yyyy');
  }
}
